var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeglogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255.788,
    height: 51.514,
    viewBox: "0 0 255.788 51.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255.787,
    height: 51.514,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56.325 -51.237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.325 51.237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.063,0V13.59L10.441,5.968,6.215,1.741,1.741,6.216l4.226,4.226,7.622,7.622H0v5.967H24.031V0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.566,72.558l-12.1.111-1.493.014-4.474.041.041,4.474.014,1.493.111,12.1.055,5.967L78.69,96.7l-.055-5.967-.07-7.622,7.691,7.552,4.265,4.188,4.433-4.515L90.69,86.147,83,78.595l7.622-.07,5.967-.055L96.533,72.5Z",
    transform: "translate(-45.239 -45.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.795,0V24.031H96.826V18.064H83.236l7.622-7.622,4.226-4.226L90.611,1.741,86.384,5.968,78.762,13.59V0Z",
    transform: "translate(-45.421 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,72.8V96.826H24.031V90.859H10.442l7.622-7.622,4.277-4.277-.2-.2-4.08-4.08-.2-.2L13.59,78.763,5.967,86.384V72.8Z",
    transform: "translate(0 -45.421)",
    fill: "#8abfed"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.426 3.256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.965,21.23l.754-1.33a6.671,6.671,0,0,0,4.878,1.951c1.863,0,3.813-.82,3.813-2.594,0-1.641-1.863-2.129-3.7-2.594-2.572-.643-5.144-1.464-5.144-4.124,0-2.572,2.461-3.88,5.033-3.88a7.429,7.429,0,0,1,4.833,1.6l-.731,1.353a6.52,6.52,0,0,0-4.1-1.33c-1.419,0-3.237.665-3.237,2.261,0,1.485,1.64,1.973,3.569,2.461,2.661.665,5.343,1.574,5.343,4.257,0,2.949-2.948,4.212-5.7,4.212a7.33,7.33,0,0,1-5.609-2.239",
    transform: "translate(-181.965 -8.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.584,16.064a7.483,7.483,0,1,1,7.493,7.405,7.341,7.341,0,0,1-7.493-7.405m13.125,0a5.644,5.644,0,1,0-11.285,0,5.644,5.644,0,1,0,11.285,0",
    transform: "translate(-221.037 -8.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.11,17.9V9.249h1.774v8.58c0,2.661,1.463,4.368,4.19,4.368,2.7,0,4.19-1.707,4.19-4.368V9.249h1.774V17.9c0,3.592-2.239,5.942-5.964,5.942-3.747,0-5.964-2.35-5.964-5.942",
    transform: "translate(-266.915 -9.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.369,10.8h-5.343V9.248h12.438V10.8h-5.321V23.616h-1.774Z",
    transform: "translate(-306.797 -9.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,9.248h1.774v5.92h8.314V9.248h1.774V23.616h-1.774V16.7h-8.314v6.918H447.77Z",
    transform: "translate(-347.818 -9.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.047,9.248h10.864V10.8h-9.09v4.368h8.513V16.7h-8.513v5.366h9.422v1.552h-11.2Z",
    transform: "translate(-389.797 -9.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.078,9.248h5.9c3.991,0,6.164,2.417,6.164,5.41a5.075,5.075,0,0,1-3.3,4.767l3.414,4.191h-2.106l-2.927-3.7a8.651,8.651,0,0,1-1.4.111h-3.968v3.592h-1.774Zm6.031,9.245a3.869,3.869,0,1,0,.022-7.716h-4.279v7.716Z",
    transform: "translate(-429.125 -9.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644,9.248h1.774l7.162,9.334c.731.976,1.53,2.328,1.53,2.328V9.248h1.774V23.615h-1.818L647.39,14.5a23.9,23.9,0,0,1-1.619-2.483v11.6H644Z",
    transform: "translate(-470.257 -9.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.011,70.23h16.67v2.381H188.732v6.7H201.8v2.347H188.732v8.233h14.459v2.381h-17.18Z",
    transform: "translate(-184.489 -47.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.736,81.831l-8.879-11.6h3.13l5.851,7.45c.715.953,1.259,1.837,1.259,1.837s.646-.919,1.327-1.837l5.75-7.45h3.164L247.458,81.8V92.275h-2.722Z",
    transform: "translate(-215.592 -47.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.367,70.23h16.67v2.381H301.088v6.7h13.064v2.347H301.088v8.233h14.459v2.381h-17.18Z",
    transform: "translate(-254.596 -47.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,80.688a11.549,11.549,0,0,1,19.153-8.5l-1.633,1.871a8.857,8.857,0,1,0-6.022,15.513,8.518,8.518,0,0,0,6.872-3.47V81.47h-4.8V79.157h7.45v7.926a11.54,11.54,0,0,1-21.024-6.4",
    transform: "translate(-300.035 -46.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.214,70.23h9.049c6.123,0,9.457,3.708,9.457,8.3a7.786,7.786,0,0,1-5.069,7.314l5.239,6.429h-3.232l-4.491-5.681a13.333,13.333,0,0,1-2.143.17h-6.089v5.511h-2.722Zm9.254,14.186c3.742,0,6.4-2.654,6.4-5.885a6.02,6.02,0,0,0-6.362-5.953h-6.566V84.416Z",
    transform: "translate(-343.103 -47.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.749,80.688a11.482,11.482,0,1,1,11.5,11.363,11.265,11.265,0,0,1-11.5-11.363m20.14,0a8.661,8.661,0,1,0-8.641,8.879,8.685,8.685,0,0,0,8.641-8.879",
    transform: "translate(-379.004 -46.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.4,83.5V70.231h2.721V83.4c0,4.082,2.245,6.7,6.43,6.7,4.15,0,6.43-2.619,6.43-6.7V70.231H587.7V83.5c0,5.511-3.436,9.117-9.151,9.117-5.749,0-9.151-3.606-9.151-9.117",
    transform: "translate(-423.709 -47.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.094,70.23h9.049c6.09,0,9.424,3.708,9.424,8.267s-3.334,8.266-9.458,8.266h-6.293v5.511h-2.721Zm9.287,14.152c3.878,0,6.361-2.654,6.361-5.885s-2.483-5.886-6.328-5.886h-6.6V84.382Z",
    transform: "translate(-462.205 -47.077)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeglogo);
export default __webpack_public_path__ + "static/media/seglogo.bd15620a59de106eb91384a02d16f688.svg";
export { ForwardRef as ReactComponent };